import HttpHelper from "../helper";

export const userTotalPointsEndpoints = {
    getPoints: (params) =>
        HttpHelper.baseAxios
            .get(`/userPoints`, { params })
            .then((res) => res?.data)
};